<!-- 搜索框逐渐 -->
<template>
<div class='cm_search_container'>
  <input type="text" placeholder="请输搜索入关键字" v-model="keywords">
  <router-link :to="{path:'/search',query:{keywords:JSON.stringify(keywords)}}">搜索</router-link>
</div>
</template>

<script>
export default {
components: {},
data() {
//这里存放数据
return {
  keywords:""
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},

}
</script>
<style scoped>
.cm_search_container{
  display: flex;
  flex-wrap: nowrap;

}
.cm_search_container>input{
  width: 240px;
  height: 40px;
  /* color: #fff ; */
  padding: 10px;
  outline: none;
  border: none;
  background:rgba(255,255,255,1);
  border-radius: 4px 0 0 4px;
}
input::-webkit-input-placeholder {
    color:#999;
    font-size: 14px;
}
.cm_search_container>a{
  display: flex;
  color: #fff;
  width:71px;
  height:40px;
  background:rgba(67,121,211,1);
  border-radius:0px 4px 4px 0px;
  font-size: 14px;
  align-items: center;
  justify-content: center;
}
</style>
